import { colors as themeColors } from './utils/theme';
import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    // ───────────────────────────────────────────────────────────────────────────
    // PAGE
    // ───────────────────────────────────────────────────────────────────────────
    page: {
        padding: '30pt',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        paddingBottom: 150,     // reserve space for footer
        position: 'relative',  // allows the footer/total to be absolutely positioned
    },

    // ───────────────────────────────────────────────────────────────────────────
    // SECTION 1: HEADER
    // ───────────────────────────────────────────────────────────────────────────
    Header: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 10, // leave space below the header for the table
        paddingBottom: 0,
    },
    subSectionA: {
        width: "30%",
        display: "flex",
        justifyContent: "center",
    },

    subSectionB: {
        width: "80%",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        textAlign: "right",
    },
    logo: {
        width: 70,
        height: 50,
    },
    companyName: {
        fontSize: 18,
        fontWeight: 'bold',
        alignSelf: 'right',      // let Text size to content, but still center it in parent
        textAlign: 'center',      // center text inside its own width (for multiline)
        paddingHorizontal: 8,     // optional breathing room
        maxWidth: '95%',          // optional: prevent it from overflowing the screen
    },
    smallText: {
        fontSize: 8,
        marginBottom: 2,
    },

    // ───────────────────────────────────────────────────────────────────────────
    // TAX INVOICE ROW
    // ───────────────────────────────────────────────────────────────────────────
    taxInvoiceRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginVertical: 0,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'black',
        padding: 2,
    },
    leftText: {
        flex: 1,
        textAlign: 'left',
        fontSize: 10, // Adjust font size as needed
        fontWeight: 'bold',
    },
    centerText: {
        flex: 1,
        textAlign: 'center',
        fontSize: 10, // Slightly larger font for emphasis
        fontWeight: 'bold',
        textTransform: 'uppercase', // Optional: capitalize "Tax Invoice"
    },
    rightText: {
        flex: 1,
        textAlign: 'right',
        fontSize: 10, // Adjust font size as needed
        fontWeight: 'bold',
    },
    
    // ───────────────────────────────────────────────────────────────────────────
    // HEADER SECTION 2
    // ───────────────────────────────────────────────────────────────────────────
    headerSection2Container: {          // ++++ position: 'absolute' | left, right = 0 | otp = 100 | zIndex = 1.
        flexDirection: 'row',
        padding:0,
        justifyContent: 'space-between',
        marginBottom: 0, // Minimized space below the container
        paddingHorizontal: 2,
        borderBottom: 1,
    },
    headerSection2Left: {
        width: '22%', // Adjust width for the new section layout
        fontSize: 10,
        lineHeight: 1.2, // Adjust line height for tighter spacing
        paddingRight: 5, // Adding padding to create space between the border and text
    },  
    headerSection2MiddleLeft: {
        width: '22%', // Adjust width for the new section layout
        fontSize: 10,
        lineHeight: 1.2, // Adjust line height for tighter spacing
        borderRight: '1px solid black', // Border between sub-sections
        paddingRight: 5, // Adding padding to create space between the border and text
    },
    headerSection2MiddleRight: {
        width: '22%', // Adjust width for the new section layout
        fontSize: 10,
        lineHeight: 1.2, // Adjust line height for tighter spacing
        paddingRight: 5, // Adding padding to create space between the border and text
    },
    headerSection2Right: {
        width: '22%', // Adjust width for the new section layout
        fontSize: 10,
        lineHeight: 1.2, // Adjust line height for tighter spacing
    },
    headerSection2: {
        marginBottom: 1, // Remove bottom margin
        marginTop: 1, // Remove top margin
        paddingBottom: 0, // Remove padding before the line
    },  

    // ───────────────────────────────────────────────────────────────────────────
    // DETAILS SECTION
    // ───────────────────────────────────────────────────────────────────────────
    detailsSectionContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 0, // Add some space between the sections
        paddingTop: 0,   // Add some top padding to give a nice separation
        paddingHorizontal: 2,
    },
    detailsSubSectionContainer: {
        
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 2, // Add some space between the sections
        paddingTop: 2,   // Add some top padding to give a nice separation
    },
    detailsSectionLeft: {
        width: '48%',
        fontSize: 10,        // Adjust font size
        paddingBottom:0,    // Some padding for spacing
        borderRight: '1px solid black',
    },
    detailsSectionRight: {
        width: '50%',
        fontSize: 10,        // Adjust font size
        paddingBottom: 0,    // Some padding for spacing
    },
    
    // ───────────────────────────────────────────────────────────────────────────
    // TABLE ▸ flows in normal document order under the header and stretches down
    // ───────────────────────────────────────────────────────────────────────────
    tableContainer: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderLeft: 1,
        borderRight: 1,
        borderColor: themeColors.neutral.black,
        borderBottom: 1,
        flexGrow: 1,        // stretch to fill space between header and totalSection
        marginBottom: 0,    // no extra margin
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCell: {
        flex: 1,
        paddingVertical: 3,
        borderStyle: 'solid',
        paddingBottom: 1,
        borderRight: 1,
        borderColor: themeColors.neutral.black,
        fontSize: 8,
    },
    tableCellLast: {
        flex: 1,
        paddingVertical: 3,
        borderStyle: 'solid',
        paddingBottom: 1,
        borderColor: themeColors.neutral.black,
        fontSize: 8,
    },
    serialNumberCell: {
        flex: 0.3,
        width: '2%',
        textAlign: 'center',
    },
    descriptionCell: {
        flex: 3,
        textAlign: 'left',
        fontSize: 8,
        paddingLeft: 4,
    },
    descriptionHeaderCell: {
        flex: 2,
        textAlign: 'center',
        fontSize: 9,
        paddingLeft: 4,
    },
    lastRow: {
        borderBottomWidth: 1,
    },
    lastCell: {
        borderRightWidth: 0,
    },
    ItemHeaderCell: {
        height: 'auto',
        paddingVertical: 3,
        backgroundColor: '#f2f2f2',
        fontWeight: 'bold',
        textAlign: 'center',
        borderStyle: 'solid',
        borderRight: 1,
        borderTop: 1,
        borderBottom: 1,
        borderColor: themeColors.neutral.black,
    },
    ItemHeaderCellLast: {
        height: 'auto',
        paddingVertical: 3,
        backgroundColor: '#f2f2f2',
        fontWeight: 'bold',
        textAlign: 'center',
        borderStyle: 'solid',

        borderTop: 1,
        borderBottom: 1,
        borderColor: themeColors.neutral.black,
    },
    rightAlign: {
        textAlign: 'right',
    },
    centerAlign: {
        textAlign: 'center',
    },

    // ───────────────────────────────────────────────────────────────────────────
    // VERTICAL LINE EXTENSION (unchanged)
    // ───────────────────────────────────────────────────────────────────────────
    tableBottomLine: {
        position: 'absolute',
        left: 60,    // adjust to align with description column’s right
        top: 600,    // adjust to table’s bottom Y if needed
        bottom: 70,  // 70pt above page bottom so it stops above footer
        width: 1,
        backgroundColor: themeColors.neutral.black,
        zIndex: 1,
    },


    // ───────────────────────────────────────────────────────────────────────────
    // TOTAL SECTION ▸ fixed right above footer, not affecting table flow
    // ───────────────────────────────────────────────────────────────────────────
    totalSection: {
        position: 'absolute',
        bottom: 84,           // sits just above the footer
        left: 30.1,
        right: 30,
        marginTop: 0,
        paddingTop: 0,
        textAlign: 'right',
        zIndex: 1,

        // added left and right borders
        borderLeftWidth: 1,
        borderLeftColor: themeColors.neutral.black,
        borderRightWidth: 1,
        borderRightColor: themeColors.neutral.black,
    },
    totalText: {
        fontSize: 12,
        fontWeight: 'bold',
        paddingRight: 8,
    },

    extraText: {
        color: themeColors.neutral.surface, // White font color
    },

    // ───────────────────────────────────────────────────────────────────────────
    // FOOTER ▸ pinned at bottom; totalSection appears above it
    // ───────────────────────────────────────────────────────────────────────────
    footer: {
        paddingRight: 20,
        marginRight: 0,
        marginTop: 0,
        borderRight: 1,
        borderLeft: 1,
        borderTop: 1,
        borderBottom: 1,
        position: 'absolute',
        bottom: 33,          // pinned 7pt from page bottom
        left: 30,
        right: 30,
        height: 50.2,
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: 10,
        paddingBottom: 10,
        zIndex: 2,
        paddingHorizontal:10,
    },
    footerUpperSection: {
        flex: 1,
        paddingTop: 3,
        textAlign: 'right',
        marginBottom: 1,
    },
    footerLowerSection: {
        flex: 1,
        textAlign: 'right',
    },
    footerText: {
        fontSize: 6,
    },


    line: {
        borderBottom: 1,
        borderBottomColor: themeColors.neutral.black,
        marginVertical: 3, // Space between sections and the line
    },
    // Add styles for the content area where we need 50% width sections
    contentSection: {
        width: '50%', // Ensure content section takes up 50% of the width
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    brdrRight:{
        borderRight:1,
        borderColor: themeColors.neutral.black,
    },
    brdrLeft:{
        borderLeft:1,
        borderColor: themeColors.neutral.black,
    },
});
export default styles;